var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraffic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#316DBE",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.333 4.666h-.4c-.884 0-1.6-.716-1.6-1.6 0-.22.18-.4.4-.4H5c.149 0 .29.033.417.091.247-.824 1.012-1.424 1.916-1.424h5.333c.905 0 1.669.6 1.916 1.424.127-.058.269-.09.418-.09h1.266c.221 0 .4.178.4.4 0 .883-.716 1.6-1.6 1.6h-.4v3.39C14.771 8.02 14.883 8 15 8h1.266c.221 0 .4.179.4.4 0 .883-.716 1.6-1.6 1.6h-.4v3.39c.105-.037.217-.057.334-.057h1.266c.221 0 .4.18.4.4 0 .884-.716 1.6-1.6 1.6h-.4v1.333c0 1.105-.895 2-2 2H7.333c-1.105 0-2-.895-2-2v-1.333h-.4c-.884 0-1.6-.716-1.6-1.6 0-.22.18-.4.4-.4H5c.117 0 .229.02.333.057V10h-.4c-.884 0-1.6-.717-1.6-1.6 0-.221.18-.4.4-.4H5c.117 0 .229.02.333.057v-3.39zm4.444 2.115c1.105 0 2-.921 2-2.058 0-1.136-.895-2.057-2-2.057-1.104 0-2 .921-2 2.057 0 1.137.896 2.058 2 2.058zm2 3.276c0 1.136-.895 2.057-2 2.057-1.104 0-2-.921-2-2.057S8.673 8 9.777 8c1.105 0 2 .92 2 2.057zm-2 7.39c1.105 0 2-.92 2-2.057 0-1.136-.895-2.057-2-2.057-1.104 0-2 .921-2 2.057s.896 2.057 2 2.057z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraffic);
export default __webpack_public_path__ + "static/media/traffic.98bab97ba7d738de6b517867adcdfaac.svg";
export { ForwardRef as ReactComponent };